import React from 'react';
import { View, Image, Text, TouchableOpacity } from 'react-native-web';
import PropTypes from 'prop-types';
import { stringIsEmpty } from "../../helpers/stringCheker";
import { onFileRead } from "../../helpers/onFileRead";
import { Button } from "..";

class SquareImageSelection extends React.Component {

    state = {
        imageToRender: null,
        imageStripped: null
    };

    renderImagePreview = () => {

    	let { data, previewUseUrl, displaySize } = this.props;
    	const { width, height } = displaySize ? displaySize : { width: 128, height: 128 };

    	const description = this.props.description ? this.props.description : 'Adicionar imagem\nSolte uma imagem aqui'

        if(stringIsEmpty(data)) return (
        	<div
	        	onDrop={ event => {
	        		event.preventDefault();
	        		onFileRead(event, this.props.onImageChange, 'drag');
	        	}}
        		onDragOver={ event => event.preventDefault()}
        		onDragEnter={ event => event.preventDefault()}
        	>
            <label htmlFor='invisibleInput'>
	        	<TouchableOpacity style={{ justifyContent: 'center', width: width, height: height, backgroundColor: '#E9E9E9'}}>
	            	<input
						type='file'
						id='invisibleInput'
						onChange={ e => onFileRead(e, this.props.onImageChange)}
						accept='image/png, image/jpeg'
						style={{ display: 'none' }}
					/>

					<Text style={{ color: '#808080', textAlign: 'center' }}>
						<Text style={{ fontWeight: 'bold', fontSize: 20 }}>
							{'\uFF0B\n'}
						</Text>
						{description}
					</Text>

				</TouchableOpacity>
	        </label>
	        </div>
        )

        if (previewUseUrl)
            data = `data:image/jpeg;base64,${data}`;

        return (
            <Image
                source={{ uri: data}}
                style={{ height: height, width: width, backgroundColor: '#E9E9E9' }}
                resizeMode={'contain'}
            />
        )
    };

    onImageRemove = () => {
        this.props.onImageChange('');
    };

    render() {

        return (
            <View style={{ margin: 10, padding: 12, alignSelf: 'center', alignItems: 'center' }}>
                <Text style={{ fontWeight: 'bold' }}>
                	{ this.props.title ? this.props.title : 'Imagem' }
                	<Text style={{ color: '#2285C2' }}> *</Text>
                </Text>
                <Text style={{ color: '#808080', fontWeight: 'bold', marginBottom: 4 }}>
                	{`${this.props.imageSize.width} x ${this.props.imageSize.height}`}
                </Text>

                <View style={{ padding: 15 }}>
                    { this.renderImagePreview() }

                    {
                        stringIsEmpty(this.props.data) === false &&
                            <Button
                                onPress={this.onImageRemove}
                                text={'\uFE63'}
                                textPropsStyle={{ fontSize: 36 }}
                                containerPropsStyle={{
                                    alignSelf: 'flex-end',
                                    position: 'absolute',
                                    right: 0,
                                    bottom: 0,
                                    height: 30,
                                    borderRadius: 30,
                                    width: 30,
                                    backgroundColor: '#800000',
                                    borderWidth: null,
                                }}
                            />
                    }
                </View>
            </View>
        )
    }
}

SquareImageSelection.propTypes = {
    onImageChange: PropTypes.func.isRequired,
    data: PropTypes.string,
    previewUseUrl: PropTypes.bool.isRequired,
    title: PropTypes.string,
    displaySize: PropTypes.object,
	imageSize: PropTypes.object,
    description: PropTypes.string
};

export { SquareImageSelection }
